import React, { FC, ReactNode, useEffect } from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { getUser } from "shared-auth";
import { registerMaintenanceApiBlocking } from "shared-utils";
import { buildUser } from "./utils";
import config from "../../config";

type LaunchDarklyProviderProps = {
  children: ReactNode;
};

const LaunchDarklyProvider: FC<
  React.PropsWithChildren<LaunchDarklyProviderProps>
> = ({ children }) => {
  const user = getUser();

  useEffect(() => {
    registerMaintenanceApiBlocking();
  }, []);

  return (
    <LDProvider
      clientSideID={config.launchDarkly.clientSideID}
      context={{
        kind: "user",
        ...buildUser(user),
      }}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
    >
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyProvider;
